export default __webpack_public_path__ + "static/media/1.04b782e8.jpg";